import http from '@/http'
const URL = '/admin/carta-pax'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const save = (id, payload) => {
  if (id) {
    return http.put(URL + `/${id}`, payload)
  }
  return http.post(URL, payload)
}

export const remove = async (id) => http.delete(URL + `/${id}`)
export const duplicate = (id) => http.post(URL + `/${id}/duplicate`)

export const preview = (id, participantId) => {
  return http.post(URL + `/${id}/preview`, { participant_id: participantId }, { responseType: 'blob' })
}

export const generate = (id, payload) => {
  if (payload.mode === 'download') {
    return http.post(URL + `/${id}/generate`, payload, { responseType: 'blob' })
  }
  return http.post(URL + `/${id}/generate`, payload)
}

export const uploadImage = (formData) => http.post(URL + '/upload-image', formData)

export const listSends = (id, params) => http.get(URL + `/${id}/sends`, { params })
export const resendFailed = (id) => http.post(URL + `/${id}/resend-failed`)
export const resendChanged = (id) => http.post(URL + `/${id}/resend-changed`)
export const participantSends = (participantId) => http.get(`/admin/participants/${participantId}/carta-pax-sends`)

// Reference data
export const getGroups = async () => http.get('/admin/settings/groups')
export const getTags = async () => http.get('/admin/tags')
export const searchParticipants = async (params) => http.get('/admin/participants', { params })

export default {
  list,
  show,
  save,
  remove,
  duplicate,
  preview,
  generate,
  uploadImage,
  listSends,
  resendFailed,
  resendChanged,
  participantSends,
  getGroups,
  getTags,
  searchParticipants
}
